import React, { useState, useCallback, useEffect } from 'react';

const Input = props => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (props.default) {
      props.refText.current = props.default;
      setValue(props.default);
    }
  }, [props.default]);

  const handleValueChange = useCallback(e => {
    const { value } = e.target;

    if (props.refText) {
      props.refText.current = value;
      console.log('PROPS REFTEXT CURRENT', props.refText.current);
    }

    setValue(value);
  }, [props.refText]);

  return (
    <input
      value={value}
      type={props.type}
      placeholder={props.placeholder}
      onChange={handleValueChange}
    />
  );
}

export default Input;